import {types} from '../../types';

const setWithdrawalsAction = (payload) => {
    return {
        type: types.common.SET_WITHDRAWALS_MOBILE,
        payload,
      }
}

export {
  setWithdrawalsAction as SetWithdrawalsAction
}